import React from "react";
import { IAddSellerInput } from "muminsmart-utils";
import { useFormContext, useWatch } from "react-hook-form";

const SUMMARY_FIELDS = [
  ["Business Name", "name"],
  ["Phone No", "phoneNumber"],
  ["Email", "email"],
  ["Password", "password"],
  ["Address Line 1", "addressLine1"],
  ["Address Line 2", "addressLine2"],
  ["Country", "country"],
  ["State", "state"],
  ["City", "city"],
  ["Postal Code", "postalCode"],
  ["GST No", "gstNumber"],
  ["PAN No", "panNumber"],
  ["Gumasta License", "gumastaLicense"],
  ["CIN No", "cinNumber"],
] as const satisfies ReadonlyArray<readonly [string, keyof IAddSellerInput]>;

const SignupSummary = React.memo(function SignupSummary() {
  const form = useFormContext<IAddSellerInput>();
  const formData = useWatch({ control: form.control }) as IAddSellerInput;

  const summaryData = React.useMemo(() => {
    const password = formData?.password ?? "";
    const maskedPassword = "*".repeat(password.length);

    return SUMMARY_FIELDS.map(([label, field]) => ({
      label,
      value: field === "password" ? maskedPassword : (formData?.[field] ?? ""),
    }));
  }, [formData]);

  return (
    <div className="space-y-5 rounded-t-3xl">
      {summaryData.map((item) => (
        <div key={item.label} className="flex justify-between">
          <span className="text-gray-700">{item.label}</span>
          <span className=" text-right">{item.value}</span>
        </div>
      ))}
    </div>
  );
});

SignupSummary.displayName = "SignupSummary";

export default SignupSummary;
